import { createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../api";
import { apiUrlV1 } from "../../../config/config";
import { handlerNeedUpdate } from "../coinFlipTableStore";
import { addNotification } from "../../Notification/notificateStore";
import { CoinEntity, CoinResponseConfig, ICoinGlobalSettings } from "../../../entities/coinGame";

const coinGameUrl = apiUrlV1 + "/v2/organization/game/coin-flip";

/**
 * создание игры Coin Flip.
 *
 * @param {ICoinGlobalSettings} data Данные формы, типа {@link ICoinGlobalSettings}
 *
 * @returns полный объект с пустым конфигом ({@link CoinEntity})
 */
export const postCoinEntity = createAsyncThunk(
  "coin/post-entity",
  async (params: { data: ICoinGlobalSettings }, thunksApi): Promise<CoinEntity> => {
    try {
      const response = await agent.post(
        `${coinGameUrl}/create/from-global-settings`,
        {
          body: JSON.stringify(params.data),
        }
      );
      if (response.ok) {
        const data = await response.json() as CoinEntity;
        thunksApi.dispatch(handlerNeedUpdate());
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        return data;
      }
      if (!response.ok) {
        const data = await response.json() as { message: string }
        thunksApi.dispatch(addNotification({ status: 'error', text: data.message }))
      }

      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);

/**
 * Получени данных об игре по id
 * 
 * @param {number} id ID игры.
 * 
 * @returns полный объект ({@link CoinEntity})
 */
export const getEntityById = createAsyncThunk(
  'coin/get-entity',
  async (param: { id: number }): Promise<CoinEntity> => {
    try {
      const response = await agent.get(`${coinGameUrl}/read/${param.id}`)
      if (response.ok) {
        const data = await response.json() as CoinEntity;
        return data;
      }
      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

/**
 * изменения в игре Coin Flip.
 *
 * @param {CoinResponseConfig} data Данные формы, типа {@link CoinResponseConfig}
 * @param {number} id ID игры.
 * 
 * @returns полный объект ({@link CoinEntity})
 */
export const patchCoinEntity = createAsyncThunk(
  "coin/patch-entity",
  async (params: { data: CoinResponseConfig, id: number }, thunksApi): Promise<CoinEntity> => {
    try {
      const response = await agent.patch(
        `${coinGameUrl}/update/from-config-part/${params.id}`,
        {
          body: JSON.stringify(params.data),
        }
      );
      if (response.ok) {
        const data = await response.json() as CoinEntity;
        thunksApi.dispatch(handlerNeedUpdate());
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        return data;
      }
      if (!response.ok) {
        const data = await response.json() as { message: string }
        thunksApi.dispatch(addNotification({ status: 'error', text: data.message }))
      }

      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
);